import { trackMetaEvent } from './metaPixel'

const inFlight = {}
const channelKey = 'meta.depositChannels.v1'
let channels = {}
try { channels = JSON.parse(window.sessionStorage.getItem(channelKey)) || {} } catch (e) {}
if (typeof channels !== 'object' || Array.isArray(channels)) channels = {}
Object.keys(channels).forEach(key => { if (channels[key] < Date.now() - 86400000) delete channels[key] })

function reportChannel (key, send) {
  if (channels[key]) return true
  try {
    send()
    channels[key] = Date.now()
    try { window.sessionStorage.setItem(channelKey, JSON.stringify(channels)) } catch (e) {}
    return true
  } catch (e) { return false }
}

// A single backend flag is shared by the channels. Do not consume it when none ran.
export function reportDeposits ({ UUID, config, query, update, app = false }) {
  if (!UUID) return Promise.resolve()
  if (inFlight[UUID]) return inFlight[UUID]
  const { pageBuryingId, sharechatId } = config
  const queryOrders = type => {
    try { return query({ type, UUID }) } catch (error) { return Promise.reject(error) }
  }
  inFlight[UUID] = Promise.all([1, 2].map(type => queryOrders(type).then(([data, error]) => {
    if (error || !data || !Array.isArray(data.list)) return
    // Snapshot and enqueue every order in this callback, before waiting for the SDK.
    return Promise.all(data.list.map(record => {
      if (!record || (record.report !== 0 && record.report !== '0') || record.id == null) return
      try {
        const id = record.id
        const details = typeof record.orderDetails === 'string' ? JSON.parse(record.orderDetails) : record.orderDetails
        if (!details || details.orderAmount == null || details.orderAmount === '') return
        const amount = Number(details.orderAmount)
        if (!isFinite(amount) || amount <= 0) return
        let reported = false
        const metaResult = pageBuryingId ? trackMetaEvent('Purchase', {
          value: amount,
          currency: 'INR',
          deposit_type: type === 1 ? 'first' : 'repeat'
        }, 'deposit:' + type + ':' + id, pageBuryingId) : Promise.resolve(true)
        if (app && typeof window.actionLogEvent === 'function') {
          const appReported = reportChannel('app:' + type + ':' + id, () => {
            window.actionLogEvent(type === 1 ? 'af_firstrecharge' : 'af_recharge', { af_revenue: amount })
          })
          reported = appReported || reported
        }
        if (sharechatId && typeof window.scq === 'function') {
          const shareReported = reportChannel('sharechat:' + sharechatId + ':' + type + ':' + id,
            () => window.scq('Purchase', 'pre_defined'))
          reported = shareReported || reported
        }
        return metaResult.then(metaReported => {
          if (metaReported && (pageBuryingId || reported)) return update({ id, UUID })
        }).catch(() => {})
      } catch (e) { /* Leave this record pending and continue with the remaining orders. */ }
    }))
  }).catch(() => {}))).then(() => { delete inFlight[UUID] })
  return inFlight[UUID]
}



// WEBPACK FOOTER //
// ./src/common/utils/reportDeposits.js